import React, { Component } from 'react';
import { arrowBack } from '../../../Images/GenericSVG';
import { Singleton } from '../../../js/Singleton';
import { STATES_INTEGRATION } from '../../../constants'

export default class IntegrationConnectButton extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.timmerName = null;
    this.state = {
      [STATES_INTEGRATION.connected]: this.language.getText("GUIIntegrationdisconnect"),
      [STATES_INTEGRATION.connecting]: this.language.getText("GUIIntegrationconnecting"),
      [STATES_INTEGRATION.disconnecting]: this.language.getText("GUIIntegrationconnect"),
      [STATES_INTEGRATION.notFound]: this.language.getText("GUIIntegrationretry")
    }
    this.timmerTitile = null;
  }
  componentDidMount() {
    let _this = this;
    this.timmerTitile = setInterval(() => {
      let titleIntegration = _this.language.getText("GUIIntegrationdisconnect");
      if (titleIntegration) {
        clearInterval(_this.timmerTitile);
        _this.setState({
          [STATES_INTEGRATION.connected]: this.language.getText("GUIIntegrationdisconnect"),
          [STATES_INTEGRATION.connecting]: this.language.getText("GUIIntegrationconnecting"),
          [STATES_INTEGRATION.disconnecting]: this.language.getText("GUIIntegrationconnect"),
          [STATES_INTEGRATION.notFound]: this.language.getText("GUIIntegrationretry")
        });
      }
    }, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timmerName);
  }

  render() {
    return (
      <div className="connectIntegrationComponent">
        {this.props.stateIntegration === STATES_INTEGRATION.connecting ?
          <div className="buttonConnectingIntegration" ></div>
          : <div className="buttonConnectIntegration" onClick={() => this.props.connectingAction()}>{this.state[this.props.stateIntegration]}</div>
        }
        <div className="buttonCircleConnectIntegration rotate" onClick={() => this.props.sendToLog()}>{arrowBack}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/IntegrationConnectButton.jsx